const SLOT_STATES = {
  free: { label: "Disponible", color: "#4caa2aff" },
  booked: { label: "Réservé", color: "#FFBB38" },
  canceled: { label: "RDV annulé", color: "#8E7CC3" },
  blocked: { label: "Bloqué", color: "#FF5733" },
  closed: { label: "Fermé", color: "#6B7280" },
  leave: { label: "Congé", color: "#C2C2C2" },
  publicHoliday: { label: "Jour férié", color: "#7FA7C9" },
};

const LEGEND_STATES = [
  "free",
  "booked",
  "canceled",
  "blocked",
  "closed",
  "leave",
  "publicHoliday",
];

// A live RDV wins over a leave or a public holiday: the conflict must show.
const getSlotState = ({
  liveAppointments,
  canceledAppointments,
  isPublicHoliday,
  isLeave,
  isDom,
  isOpened,
  isBlocked,
}) => {
  if (liveAppointments) return "booked";
  if (isPublicHoliday) return "publicHoliday";
  if (isLeave) return "leave";
  if (canceledAppointments) return "canceled";
  if (isDom) return isOpened ? "free" : "closed";
  return isBlocked ? "blocked" : "free";
};

export { SLOT_STATES, LEGEND_STATES, getSlotState };
